import { styled } from "@linaria/react";
import { ReactNode } from "react";
import { COLOR_SHADOW } from "../../constants";
const StyledBanner = /*#__PURE__*/styled("div")({
  name: "StyledBanner",
  class: "s3t2ik8"
});
const ButtonClose = /*#__PURE__*/styled("button")({
  name: "ButtonClose",
  class: "bl3kxkn"
});
const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "c18wq0aa"
});
const Print = /*#__PURE__*/styled("div")({
  name: "Print",
  class: "p1k2p0uj"
});
type Props = {
  hide(): void;
  children?: ReactNode;
};
export default function Banner(props: Props): JSX.Element {
  return <StyledBanner>
      <Content>
        <Print>
          <ButtonClose onClick={props.hide} aria-label="Close Banner">
            &times;
          </ButtonClose>
          {props.children}
        </Print>
      </Content>
    </StyledBanner>;
}

require("../../../.linaria-cache/src/components/Banner/index.linaria.module.css");